const number = {}


number.install = function(Vue){
    Vue.directive('number', {        
        inserted(el){
            //setFocus(el, binding)
            el.oninput = function(event) {
                event.target.value = event.target.value.replace(/[^0-9]*/g,'');
            }

            el.onkeydown = function(event){
                if(event.key==='.'){
                    event.preventDefault();
                }
            }       
        }
    })
}

export default number